import { style } from '@mui/system';
import { Chart } from 'chart.js';
import React, { FC, forwardRef, useEffect, useRef, useState } from 'react';
import { Building, Project, Site } from '../../confi-state';
import { isProdOrDevEnv } from '../../environment.enum';
import BuildingInfo from '../BuildingInfo/BuildingInfo';
import BuildingInfoDoc from '../BuildingInfoDoc/BuildingInfoDoc';
import SiteInfo from '../SiteInfo/SiteInfo';
import SiteInfoDoc from '../SiteInfoDoc/SiteInfoDoc';
import WishChart from '../WishChart/WishChart';
import WishChartBuildings from '../WishChartBuildings/WishChartBuildings';
import styles from './DocumentationPagePrint.module.css';

export interface DocumentationPagePrintProps {
    siteImagePerspective1: string;
    siteImagePerspective2: string;
    siteImageTop: string;
    buildings: Building[],
    currentSite: Site;
    currentProject: Project;
    buildingImages: { perspective1: string, perspective2: string, top: string }[]
}

const DocumentationPagePrint = forwardRef((props: DocumentationPagePrintProps, ref) => {

    const canvasRef = useRef<HTMLCanvasElement>(undefined);
    const firstRenderRef = useRef(true);

    useEffect(() => {
        if (!isProdOrDevEnv() && firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
    }, [canvasRef]);

    return (
        <div ref={ref as any} className={styles.DocumentationPagePrint} data-testid="DocumentationPagePrint">
            <div className={styles.page}>
                <h1>Documenten</h1>
                <h2>
                    <span className={styles.subject}>
                        Project
                        <span className={styles.title}>
                            {props.currentProject.name}
                        </span>
                    </span>
                    <span>
                        Kavel
                        <span className={styles.title}>
                            {props.currentSite.name}
                        </span>
                    </span>
                </h2>
                <div className={styles.rowFlex}>
                    <div className={`${styles.top} ${styles.division}`}>
                        <div className={styles.left}>
                            {
                                props.currentSite && <SiteInfoDoc currentSite={props.currentSite} buildings={props.buildings} />
                            }
                        </div>
                        <div className={styles.right}>
                            <WishChartBuildings buildings={props.buildings} />
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <div className={styles.siteImagePerspective1}>
                            <span className={styles.imageTitle}>Perspective 1</span>
                            <img className={styles.printImage} src={props.siteImagePerspective1}></img>
                        </div>
                        <div>
                            <div className={styles.siteImage}>
                                <span className={styles.imageTitle}>Perspective 2</span>
                                <img className={styles.printImage} src={props.siteImagePerspective2}>
                                </img>
                            </div>
                            <div className={styles.siteImage}>
                                <span className={styles.imageTitle}>Top</span>
                                <img className={styles.printImage} src={props.siteImageTop}>
                                </img>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {props.buildings.map((b, index) => {
                return (<div className={styles.page} key={b.id + index.toString()}>
                    <h2>
                        <span className={styles.subject}>
                            Gebouw
                            <span className={styles.title}>
                                {b.name}
                            </span>
                        </span>
                    </h2>
                    <div className={styles.rowFlex}>
                        <div className={`${styles.top} ${styles.division}`}>
                            <div className={styles.left}>
                                <BuildingInfoDoc building={b} />
                            </div>
                            <div className={styles.right}>
                                <WishChart currentBuilding={b}></WishChart>
                            </div>
                        </div>
                        <div className={styles.bottom}>
                            {
                                props.buildingImages.length === props.buildings.length &&
                                <>
                                    <div className={styles.siteImagePerspective1}>
                                        <span className={styles.imageTitle}>Perspective 1</span>
                                        <img className={styles.printImage} src={props.buildingImages[index].perspective1}></img>
                                    </div>
                                    <div>
                                        <div className={styles.siteImage}>
                                            <span className={styles.imageTitle}>Perspective 2</span>
                                            <img className={styles.printImage} src={props.buildingImages[index].perspective2}>
                                            </img>
                                        </div>
                                        <div className={styles.siteImage}>
                                            <span className={styles.imageTitle}>Top</span>
                                            <img className={styles.printImage} src={props.buildingImages[index].top}>
                                            </img>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>)
            })}
        </div>
    )
});

export default DocumentationPagePrint;
